import { ICategoryInitialState } from "../Interfaces/ICategory";

export const CategoryInitialState: ICategoryInitialState = {
    isLoadingCategoryDashboard: false,
    categories: []
}